module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7f943e03dbb86eddfde951af1c5bafc1.png";